namespace RedBullMOBILE360.Web.Models {
    export interface OSNSMS {
        MSISDN?: string;
        Message?: string;
    }
}
